import { StoreApi, UseBoundStore, useStore } from "zustand";
import {
  WechatContactsStoreType,
  wechatContactsStore,
} from "./wechat-contacts-store";
import {
  wechatContactsPersistentStore,
  WechatContactsPersistentStoreType,
} from "./wechat-contacts-persistent-store";

export const useWechatContactsStore = useStore.bind(
  null,
  wechatContactsStore.getStore()
) as UseBoundStore<StoreApi<WechatContactsStoreType>>;

export const useWechatContactsPersistentStore = useStore.bind(
  null,
  wechatContactsPersistentStore.getStore()
) as UseBoundStore<StoreApi<WechatContactsPersistentStoreType>>;
